import { BackfillNov4Event } from '@/components/attendance/BackfillNov4Event';

export default function BackfillEventPage() {
  return (
    <div className="container mx-auto py-8">
      <BackfillNov4Event />
    </div>
  );
}
